import React, { useState } from "react";
import WmsCollapse from "../react/components/WmsCollapse/WmsCollapse";
import WmsDropdown from "../react/components/WmsDropdown/WmsDropdown";
import WmsInput from "../react/components/WmsInput/WmsInput";
import WmsButton from "../react/components/WmsButton/WmsButton";
import { defaultCategoryOptions, rateNameOptions } from "./adjust-customer-charges-const";

declare var window: any;

interface Props {
    wmsSelector: string;
    filterObject: any;
    optionsFacility: any[];
    setIsSearchClicked: (isSearchClicked: boolean) => void;
    chargeCategoryOptions: any[];
    setSharedFilterObject: (filterObject: any) => void;
}

const PredefinedRateSearch: React.FC<Props> = (props: Props) => {
    const defaultSearchFilter = {
        category: defaultCategoryOptions.id,
        IndexOptionsRateName: rateNameOptions[0].id,
        RateName: "",
    };
    const [searchFilter, setSearchFilter] = useState(defaultSearchFilter);

    const handleFilterChange = (event: any) => {
        let { name, value } = event.target;
        setSearchFilter((previousState) => ({
            ...previousState,
            [name]: value,
        }));
        props.setSharedFilterObject((previousState) => ({
            ...previousState,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        props.setIsSearchClicked(true);
    };

    const handleClear = () => {
        props.setIsSearchClicked(true);
        setSearchFilter(defaultSearchFilter);
        props.setSharedFilterObject((previousState) => ({
            ...previousState,
            ...defaultSearchFilter,
        }));
    };

    return (
        <div className="predefined-rate-search-container">
            <WmsCollapse
                id="Label_Add_A_Charge"
                headerLabel={window.translate("Label_Select_Predefined_Rate")}
                showCollapseText={false}
                showCollapseIcon={false}
            >
                <div className="charge-selection-container">
                    <div className="charge-selection-radio-container">
                        <div className="wms-input-group-wrapper">
                            <WmsDropdown
                                id="IndexOptionsRateName"
                                name="IndexOptionsRateName"
                                label={window.translate("Label_Rate_Name")}
                                wmsSelector={props.wmsSelector + "IndexOptionsRateName"}
                                value={searchFilter.IndexOptionsRateName}
                                onChangeFunc={handleFilterChange}
                                options={rateNameOptions}
                                valueField="id"
                                textField="name"
                                parentClassName="select_box"
                            />
                            <WmsInput
                                inputName="RateName"
                                wmsSelector={props.wmsSelector + "SearchRateName"}
                                value={searchFilter.RateName}
                                onChangeFunc={handleFilterChange}
                                label={window.translate("Label_Rate_Name")}
                                parentClassName="input_box"
                            />
                        </div>
                        <WmsDropdown
                            id="category"
                            name="category"
                            label={window.translate("Label_Category")}
                            wmsSelector={props.wmsSelector + "SelectCategory"}
                            value={searchFilter.category}
                            onChangeFunc={handleFilterChange}
                            options={[
                                {
                                    id: "",
                                    name: "All Categories",
                                },
                                ...props.chargeCategoryOptions,
                            ]}
                            valueField="id"
                            textField="name"
                            parentClassName="form_group"
                        />
                    </div>
                    <div className="charge-selection-button-container">
                        <WmsButton
                            label={window.translate("Label_Search")}
                            wmsSelector={props.wmsSelector + "SearchButton"}
                            onClickFunc={handleSearch}
                            icon="fa-search"
                        />
                        <WmsButton
                            label={window.translate("Label_Clear")}
                            wmsSelector={props.wmsSelector + "ClearButton"}
                            onClickFunc={handleClear}
                            icon="fa-minus"
                            buttonType="orange"
                        />
                    </div>
                </div>
            </WmsCollapse>
        </div>
    );
};

export default PredefinedRateSearch;
